import type { CardType } from "@app/modules/cards/cards-shared-state";

export function getProductHistoryCardId(productId: string) {
	const cardType: CardType = "customer-product-history";

	return `${cardType}-${productId}`;
}
